import { query, where, orderBy } from 'firebase/firestore';
import { IHistoryPrice } from '../sp-types';
import { deleteItemsByIds, getAllItems } from './genericFB';

const COLLECTION_NAME = 'history-prices';

export async function getHistoryPrices(
  formulaId: string,
  addId: boolean = false,
): Promise<IHistoryPrice[] | undefined> {
  return await getAllItems<IHistoryPrice>(
    COLLECTION_NAME,
    (q) => query(q, where('formulaId', '==', formulaId), orderBy('date')),
    addId,
  );
}

export async function getWrongHistoryPrices(): Promise<IHistoryPrice[] | undefined> {
  return await getAllItems<IHistoryPrice>(COLLECTION_NAME, (q) => query(q, where('price', '==', 0)), true);
}

export async function deleteHistoryPrices(items: IHistoryPrice[]): Promise<void> {
  return await deleteItemsByIds(
    items.map((hp: any) => hp.id),
    COLLECTION_NAME,
  );
}

export async function getHistoryPricesSince(formulaId: string, fromDate: Date): Promise<IHistoryPrice[] | undefined> {
  try {
    return getAllItems<IHistoryPrice>(COLLECTION_NAME, (q) =>
      query(
        q,
        where('formulaId', '==', formulaId),
        where('date', '>=', fromDate.toLocaleDateString('en-CA')),
        orderBy('date'),
      ),
    );
  } catch (e) {
    console.error('mos err', e);
    return undefined;
  }
}
